
// 한글 여부 판단 함수
function isHanText(str) {
    const pattern = /[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]/g;
    return pattern.test(str);
}

// 문자열의 AS400 바이트 길이 반환
function getAS400Byte(str) {
    if (!str || str.length === 0) return 0;

    const text = str.trim();
    let totByte = 0;

    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const isFirst = i === 0;
        const isLast = i === text.length - 1;

        if (!isHanText(char)) {
            totByte += 1; // 영문, 숫자 등은 1 byte
            continue;
        }

        totByte += 2; // 기본 한글 2 byte

        // 문장 시작
        if (isFirst) totByte += 1;
        // 문장 끝
        if (isLast) totByte += 1;
        // 앞 글자가 한글이 아님
        if (!isFirst && !isHanText(text[i - 1])) totByte += 1;
        // 뒷 글자가 한글이 아님
        if (!isLast && !isHanText(text[i + 1])) totByte += 1;
    }

    return totByte;
}

// AS400 바이트 수만큼 잘라낸 문자열 반환
function getAS400String(str, maxByte) {
    if (!str || str.trim() === '') return '';

    const val = str.trim();
    for (let i = val.length; i > 0; i--) {
        const temp = val.substring(0, i);
        if (getAS400Byte(temp) <= maxByte) {
            return temp;
        }
    }
    return '';
}

// function checkCharacter($input) {
//     var $byte = $input.siblings(".byte-txt");
//     var len = $.getAS400Byte($input.val());
//     if (!$byte.length) {
//         $byte = $input.siblings().children();
//     }
//     if ($byte.length) {
//         $byte.text("(" + $.getAS400Byte($input.val()) + "/" + 40 + "byte)");
//     }
//     if (40 - len < 0) {
//         $input.val($.getAS400String($input.val(), 40));
//         if (checkhasMsgBoxAlready()) {
//             return;
//         }
//         msgboxCommon("alert", "배송메세지는 40Bytes까지 입력 가능합니다.");
//     }
// }

export default {
    getAS400Byte,
    getAS400String
}


// WEBPACK FOOTER //
// ./src/utils/helpers/as400String.js